import React, { useState } from "react";
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Typography, 
  Tabs, 
  Tab, 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow, 
  Paper,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import { COLORS } from "../../config";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`session-tabpanel-${index}`}
      aria-labelledby={`session-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className="p-3">{children}</div>
      )}
    </div>
  );
}

function SessionDetailModal({ open, onClose, session }) {
  const [tabValue, setTabValue] = useState(0);

  if (!session) return null;

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr);
    return date.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      PaperProps={{
        style: { backgroundColor: COLORS.BLACK, color: "#fff" }
      }}
      className="session-detail-modal"
    >
      <DialogTitle>
        <div className="flex flex-space-between flex-middle">
          <Typography variant="h5">{session.sessionName}</Typography>
          <IconButton aria-label="close" onClick={onClose} style={{ color: "#fff" }}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <div className="mb-4">
          <div className="flex flex-wrap">
            <div className="mr-4 mb-2">
              <Typography variant="subtitle2" color="textSecondary">Owner</Typography>
              <Typography>{session.sessionOwnerEmail}</Typography>
            </div>
            <div className="mr-4 mb-2">
              <Typography variant="subtitle2" color="textSecondary">Device</Typography>
              <Typography>{session.sessionDevice}</Typography>
            </div>
            <div className="mr-4 mb-2">
              <Typography variant="subtitle2" color="textSecondary">Start Time</Typography>
              <Typography>{formatDateTime(session.sessionStart)}</Typography>
            </div>
            <div className="mb-2">
              <Typography variant="subtitle2" color="textSecondary">End Time</Typography>
              <Typography>{formatDateTime(session.sessionStop)}</Typography>
            </div>
          </div>
        </div>

        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Activities" />
          <Tab label="Artifacts" />
          <Tab label="Jobs" />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <Paper className="table-wrapper" style={{ backgroundColor: COLORS.DARK_BG }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Time</TableCell>
                  <TableCell>Activity Type</TableCell>
                  <TableCell>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {session.activities && session.activities.map((activity) => (
                  <TableRow key={activity.id} className="tableRow">
                    <TableCell>{formatDateTime(activity.time)}</TableCell>
                    <TableCell>{activity.activityType}</TableCell>
                    <TableCell>{activity.description}</TableCell>
                  </TableRow>
                ))}
                {(!session.activities || session.activities.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">No activities found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <Paper className="table-wrapper" style={{ backgroundColor: COLORS.DARK_BG }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Start Time</TableCell>
                  <TableCell>Processed</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {session.artifacts && session.artifacts.map((artifact) => (
                  <TableRow key={artifact.id} className="tableRow">
                    <TableCell>{artifact.artifactName}</TableCell>
                    <TableCell>{artifact.artifactType}</TableCell>
                    <TableCell>{artifact.startTime ? formatDateTime(artifact.startTime) : 'N/A'}</TableCell>
                    <TableCell>{artifact.isProcessed ? 'Yes' : 'No'}</TableCell>
                    <TableCell align="right">
                      {artifact.artifactURL && (
                        <IconButton
                          size="small"
                          className="action-button"
                          href={artifact.artifactURL}
                          target="_blank"
                          rel="noopener"
                        >
                          <GetAppIcon fontSize="small" />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
                {(!session.artifacts || session.artifacts.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={5} align="center">No artifacts found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <Paper className="table-wrapper" style={{ backgroundColor: COLORS.DARK_BG }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Type</TableCell>
                  <TableCell>Init Time</TableCell>
                  <TableCell>Completed</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {session.jobs && session.jobs.map((job) => (
                  <TableRow key={job.id} className="tableRow">
                    <TableCell>{job.jobType}</TableCell>
                    <TableCell>{formatDateTime(job.jobInitTime)}</TableCell>
                    <TableCell>{job.completed ? 'Yes' : 'No'}</TableCell>
                  </TableRow>
                ))}
                {(!session.jobs || session.jobs.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={4} align="center">No jobs found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>
        </TabPanel>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SessionDetailModal;